import React, { Component, useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { BrowserRouter, Route, Link } from "react-router-dom";

const slideContent = [
  {
    title:
      "Tận hưởng tầm nhìn bao trọn không gian với cửa sổ panorama từ chiếc giường size XL là một trải nghiệm thú vị không thể bỏ lỡ. ",
    description:
      "Với 6 chế độ ánh sáng, âm thanh được thiết kế theo từng tâm trạng và tùy chỉnh dễ dàng, đừng bỏ lỡ cuộc dạo chơi cảm xúc tại căn phòng của chính bạn.",
    path: "",
    slogan: "Kích thước là chuyện nhỏ,Trải nghiệm là chuyện XL..",
  },
  {
    title:
      "Tận hưởng tầm nhìn bao trọn không gian với cửa sổ panorama từ chiếc giường size XL là một trải nghiệm thú vị không thể bỏ lỡ. ",
    description:
      "Với 6 chế độ ánh sáng, âm thanh được thiết kế theo từng tâm trạng và tùy chỉnh dễ dàng, đừng bỏ lỡ cuộc dạo chơi cảm xúc tại căn phòng của chính bạn.",
    path: "",
    slogan: "Kích thước là chuyện nhỏ,Trải nghiệm là chuyện XL..",
  },
  {
    title:
      "Tận hưởng tầm nhìn bao trọn không gian với cửa sổ panorama từ chiếc giường size XL là một trải nghiệm thú vị không thể bỏ lỡ. ",
    description:
      "Với 6 chế độ ánh sáng, âm thanh được thiết kế theo từng tâm trạng và tùy chỉnh dễ dàng, đừng bỏ lỡ cuộc dạo chơi cảm xúc tại căn phòng của chính bạn.",
    path: "",
    slogan: "Kích thước là chuyện nhỏ,Trải nghiệm là chuyện XL..",
  },
];
var time = 2;
function DestinationItem() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: (
      <div>
        <img src="/images/ic_prev.png" />
      </div>
    ),
    nextArrow: (
      <div>
        <img src="/images/ic_next.png" />
      </div>
    ),
  };
  // const [progess, setProgess] = useState(0);
  // const [isPause, setIsPause] = useState(false);
  // function interval() {
  //   if (isPause === false) {
  //     progess += 1 / (time + 0.1);
  //     if (progess >= 100) {
  //       setProgess(0);
  //     }
  //   }
  // }
  // const timer = () => setProgess(interval);
  // useEffect(() => {
  //   const id = setInterval(timer, 30);
  //   if (progess >= 100) {
  //     setProgess(0);
  //     clearInterval(id);
  //   } else return () => clearInterval(id);
  // }, [progess]);
  return (
    <div className="slideContent styleArrow">
      <Slider {...settings}>
        {slideContent.map((content) => {
          return (
            <div className="item">
              <div className="row rowRes">
                <div className="col-lg-6 col-12 col-md-7">
                  <div
                    className="itemBox"
                    style={{
                      backgroundImage: `url('/images/ic_bg_slider.png')`,
                    }}
                  >
                    <div className="content">
                      <h5>{content.title}</h5>
                      <p>{content.description}</p>
                      <BrowserRouter>
                        <Link to={content.path}>Tìm hiểu thêm</Link>
                        <span>
                          <img
                            className="iconArrow"
                            src="/images/ic_arrow.png"
                            alt=""
                          />
                        </span>
                      </BrowserRouter>
                    </div>
                    <div class="slider-progress">
                      <div class="progress"></div>
                    </div>
                  </div>
                  <div className="iconBottom">
                    <img src="/images/ic_passenger.png" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 col-12 col-md-5">
                  <div className="sloganBox">
                    <h5 className="titleStyle">{content.slogan}</h5>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
export default DestinationItem;
